import Color from 'color'
import { addDays, addMonths, startOfDay } from 'date-fns'
import { ReservationFormFieldVisibility } from '../../containers/Form/CreateReservation/withReduxForm'
import { theme } from '../../theme'
import { IBookingCalendarStore } from './index'

const finishDate = addDays(
  new Date(),
  window.screen.width < 1024
    ? Math.floor(
        (window.screen.width - 32 - theme.calendar.room.width) /
          theme.calendar.header.width,
      )
    : 30,
)

export const CALENDAR_EXTEND_LEFT = 24 // o ile powiększa się zakres przy rozszerzeniu w lewo [miesiące]
export const CALENDAR_EXTEND_RIGHT = 24 // o ile powiększa się zakres przy rozszerzeniu w prawo [miesiące]
export const CALENDAR_INITIAL_LEFT = -3 // Ile wstecz przy początkowym ładowaniu [miesiące]
export const CALENDAR_INITIAL_RIGHT = 24 // Ile do przodu przy początkowym ładowaniu [miesiące]
export const CALENDAR_SCROLL_THRESHOLD = 50 // Tyle dni od konca zakresu powoduje jego rozszerzenie (ta wartość nie może być zbyt mała) [dni]

export const customColorsArray = [
  '#e88484ff',
  '#9fe1b4ff',
  '#d9c4f1ff',
  '#ede89dff',
  '#ccccccff',
  '#393939ff',
  '#ff0033ff',
  '#ffe200ff',
  '#00a541ff',
  '#959595ff',
  '#cc00ffff',
  '#f44336ff',
  '#e91e63ff',
  '#9c27b0ff',
  '#673ab7ff',
  '#3f51b5ff',
  '#2196f3ff',
  '#03a9f4ff',
  '#00bcd4ff',
  '#009688ff',
  '#4caf50ff',
  '#8bc34aff',
  '#cddc39ff',
  '#ffeb3bff',
  '#ffc107ff',
  '#ff9800ff',
  '#ff5722ff',
  '#795548ff',
  '#9e9e9eff',
  '#607d8bff',
  '#ffffffff',
]

export default {
  customColors: customColorsArray.map(color => Color(color)),
  customReservationColors: [
    '#1cbbb4ff',
    '#448ccbff',
    '#8bc34aff',
    '#197b30ff',
    '#3cb878ff',
    '#f69679ff',
    '#f26c4fff',
    '#ed1c24ff',
    '#a0410dff',
    '#605ca8ff',
    '#0072bcff',
    '#003471ff',
    '#534741ff',
    '#736357ff',
    '#998675ff',
    '#acacacff',
    '#ffffffff',
  ].map(color => Color(color)),
  dates: {
    loaded: [],
    manual: null,
    rendered: {
      from: new Date(),
      to: finishDate,
    },
    requested: [],
    scrollable: {
      from: addMonths(startOfDay(new Date()), CALENDAR_INITIAL_LEFT),
      to: addMonths(startOfDay(new Date()), CALENDAR_INITIAL_RIGHT),
    },
  },
  deleteReservationModal: {
    id: null,
    isOpen: false,
  },
  eventLabels: {},
  filtering: {
    byDate: {},
    byPlace: {},
  },
  isSidebarBlock: false,
  isSidebarOpen: false,
  request: {
    isCalendarReady: false,
    rooms: {
      acceptedCount: 0,
      errMessage: '',
      isLoading: false,
    },
  },
  reservationModal: {
    calculatingPrice: false,
    closeModal: {
      open: false,
    },
    configModal: {
      open: false,
    },
    createForm: {
      from: startOfDay(new Date()),
      isOpen: false,
      roomId: null,
    },
    fieldVisibility: new ReservationFormFieldVisibility(),
    isSaving: false,
    loading: false,
    selectedTab: 0,
    servicesModal: {
      isLoading: false,
      open: false,
    },
    updateForm: {
      id: null,
      isOpen: false,
    },
  },
  roomModal: {
    createForm: {
      isOpen: false,
    },
    isSaving: false,
    updateForm: {
      isOpen: false,
      roomId: null,
    },
  },
  rooms: [],
  scrollIsDragging: false,
  scrollIsScrolling: false,
  scrollTop: 0,
  selectedColumns: [],
  size: {
    calendar: 0.8,
    forms: 0.85,
    profile: 0.85,
    settings: 0.85,
    showSliders: false,
  },
  summary: false,
  onboarding: false,
  survey: false
} as IBookingCalendarStore
